import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=ed8ae1b2&scoped=true&"
import script from "./UserForm.vue?vue&type=script&lang=ts&setup=true&"
export * from "./UserForm.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./UserForm.vue?vue&type=style&index=0&id=ed8ae1b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8ae1b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed8ae1b2')) {
      api.createRecord('ed8ae1b2', component.options)
    } else {
      api.reload('ed8ae1b2', component.options)
    }
    module.hot.accept("./UserForm.vue?vue&type=template&id=ed8ae1b2&scoped=true&", function () {
      api.rerender('ed8ae1b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/RegistrationForm/components/UserForm.vue"
export default component.exports